import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Card, CardContent } from '../components/ui/card';
import { Clock, ArrowRight, Tag } from 'lucide-react';

const articles = [
  {
    slug: 'future-of-ai-careers-2026',
    title: 'The Future of AI Careers in 2026: What You Need to Know',
    excerpt: 'AI is no longer just a buzzword. With generative AI, LLMs, and autonomous systems becoming mainstream, the demand for AI professionals has skyrocketed. Here is what skills you need.',
    category: 'AI & Career',
    readTime: '5 min read',
    date: 'Feb 15, 2026',
  },
  {
    slug: 'azure-vs-aws-data-engineering',
    title: 'Azure vs AWS for Data Engineering: Which Should You Learn?',
    excerpt: 'Choosing between Azure and AWS for your data engineering career? We break down the job market, certifications, tools, and salary comparisons to help you decide.',
    category: 'Data Engineering',
    readTime: '7 min read',
    date: 'Feb 10, 2026',
  },
  {
    slug: 'how-to-transition-into-tech',
    title: 'How to Transition into Tech Without a CS Degree',
    excerpt: 'You dont need a computer science degree to build a tech career. Discover proven pathways through bootcamps, certifications, and self-study that lead to high-paying roles.',
    category: 'Career Guide',
    readTime: '6 min read',
    date: 'Feb 5, 2026',
  },
  {
    slug: 'microsoft-fabric-complete-guide',
    title: 'Microsoft Fabric: The Complete Guide for Data Engineers',
    excerpt: 'Microsoft Fabric is transforming how organizations manage data. Learn about Lakehouse, Dataflows, and real-time analytics — and why companies are hiring Fabric engineers.',
    category: 'Data Engineering',
    readTime: '8 min read',
    date: 'Jan 28, 2026',
  },
  {
    slug: 'cybersecurity-jobs-india-2026',
    title: 'Cybersecurity Jobs in India: Demand, Salary & How to Start',
    excerpt: 'With increasing cyber threats, India needs 1.5 million cybersecurity professionals by 2027. Here is how to start your career in ethical hacking and SOC analysis.',
    category: 'Cyber Security',
    readTime: '5 min read',
    date: 'Jan 20, 2026',
  },
  {
    slug: 'importance-of-professional-certifications',
    title: 'Why Professional Certifications Matter More Than Ever',
    excerpt: 'In a competitive job market, certifications like AWS, Azure, and CloudXAI credentials give you a verifiable edge. Understand how certifications boost your hiring chances.',
    category: 'Certifications',
    readTime: '4 min read',
    date: 'Jan 15, 2026',
  },
];

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0F1A]">
      <Header />

      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0B0F1A] to-[#020617] relative">
        <div className="absolute bottom-10 left-1/3 w-80 h-80 bg-[#1DE9B6] rounded-full blur-[150px] opacity-10"></div>
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 font-['Space_Grotesk']" data-testid="blog-heading">
            Knowledge <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Hub</span>
          </h1>
          <p className="text-lg text-[#9CA3AF] max-w-2xl mx-auto">Insights, guides, and industry trends in AI, Data, Cloud, and Tech Careers.</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <Card key={i} className="bg-[#111827] border-2 border-[#00E5FF]/15 hover:border-[#00E5FF]/40 transition-all duration-300 group cursor-pointer">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-3 py-1 bg-[#00E5FF]/10 text-[#00E5FF] text-xs font-bold rounded-full flex items-center gap-1">
                    <Tag className="w-3 h-3" /> {a.category}
                  </span>
                  <span className="text-[#9CA3AF] text-xs flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {a.readTime}
                  </span>
                </div>
                <h2 className="text-white font-bold text-lg mb-3 group-hover:text-[#00E5FF] transition-colors leading-tight">{a.title}</h2>
                <p className="text-[#9CA3AF] text-sm leading-relaxed flex-1 mb-4">{a.excerpt}</p>
                <div className="flex items-center justify-between pt-4 border-t border-[#00E5FF]/10">
                  <span className="text-[#9CA3AF] text-xs">{a.date}</span>
                  <span className="text-[#00E5FF] text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default BlogPage;
